import { Outlet, createFileRoute } from "@tanstack/react-router";
import { BarChartSquare02 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_report")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("report", context.tenant.modules);

    return {
      title: () => context.t("Report", { ns: "report.shared" }),
      crumb: [
        {
          Icon: BarChartSquare02,
        },
        {
          label: context.t("Reports", { ns: "report.shared" }),
          link: { to: "/admin/report/reports" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
